<template>
  <div class="validate">
    <slot />
    <p :style='validator.errorStyle' v-if='validator.showError' class="error-txt">{{validatorMsg}}</p>
  </div>
</template>
<script>
export default {
  computed: {
  },
  data () {
    return {
      validatorMsg: ''
    }
  },
  methods: {
    run (validator) {
      if (!(validator && validator.validatorList)) return
      let list = validator.validatorList
      for (let i = 0; i < list.length; i++) {
        if(!list[i].func()){
          this.validatorMsg = list[i].error
          validator.showError = true
          break
        } else {
          this.validatorMsg = ''
          validator.showError = false
        }
      }
    }
  },
  watch: {
    value (cur) {
      if (this.validator.required && cur.length === 0) {
         this.validatorMsg = `请输入${this.name}`
        this.validator.showError = true
        return
      } else {
        this.validator.showError = false
      }
      this.run(this.validator)
    },
  },
  props: {
    value: {
      type: String,
    },
    name: {
      value: {
        type: String,
      },
    },
    validator: {
      value: {
        type: Object,
        require: true
      },
    },
    styleObj: {
       value: {
        type: Object,
      },
    }
  }
}
</script>
<style scoped lang="scss">
  .error-txt {
  text-align: left;
  margin: -22px auto 28px 120px;
  color: #fa5a57;
  font-size: 14px;
}
</style>